import { Observable, of } from 'rxjs';
import { inject } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { CanActivateFn, Router } from '@angular/router';
import { take, switchMap, filter, map } from 'rxjs/operators';

import * as fromRoot from '../reducers';
import { CONSTANTS } from '../constants/constants';
import { GuestService } from '../modules/core/services/guest.service';
import { BookingService } from '../modules/core/services/booking.service';

export const oExpensesNavigationGuard: CanActivateFn = (): Observable<any> => {
	const store: Store<fromRoot.AppState> = inject(Store<fromRoot.AppState>);
	const guestService: GuestService = inject(GuestService);
	const bookingService: BookingService = inject(BookingService);
	const router: Router = inject(Router);
	const constants: any = inject(CONSTANTS); 

	return store.pipe(
		select(fromRoot.getSessionState),
		filter(resData => resData.reservationRetrievalResp !== null || !!resData.error),
		take(1),
		switchMap(resData => {
			if (resData.error) {
				router.navigate([constants.ROUTES.ERROR]);
				return of(false);
			} else {
				if (!bookingService.isProgressBarEnabled) {
					router.navigate([constants.ROUTES.SELECT_GUESTS_FOR_CHECKIN]);
					return of(false);
				}
				return guestService.isGuestDetailsCompleted().pipe(map(isCompleted => {
					if (!isCompleted) {
						router.navigate([constants.ROUTES.SELECT_GUESTS_FOR_CHECKIN]);
						return false;
					}
					return true;
				}));
			}
		})
	);
}